<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">{{header.header_0}}</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 用户头像 -->
               <!-- <div class="user-avator">
					<router-link to="/userCenter">
						<img :src="userimg" :onerror="defaultImg"/>
					</router-link>
                </div> -->
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{username}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <!-- <el-dropdown-item divided command="personInfo">{{i18n.header_10}}</el-dropdown-item> -->
                        <el-dropdown-item style="border-top:none" divided command="loginout">{{header.header_11}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
				<!-- 多语言 -->
				<!-- <el-dropdown class="user-language" trigger="click" @command="handleCommand">
				    <span class="el-dropdown-link">
				        {{language}}
				        <i class="el-icon-caret-bottom"></i>
				    </span>
				    <el-dropdown-menu slot="dropdown">
				        <el-dropdown-item divided command="jp">{{header.header_1}}</el-dropdown-item>
				        <el-dropdown-item divided command="zhCHS">{{header.header_2}}</el-dropdown-item>
				    </el-dropdown-menu>
				</el-dropdown> -->
				<!-- 消息中心 -->
				<!-- <el-badge :value="message" class="btn-bell">
				    <el-tooltip
				        effect="dark"
				        :content="contentMessage"
				        placement="bottom"
				    >
				        <router-link to="/messageList">
				            <i class="el-icon-bell"></i>
				        </router-link>
				    </el-tooltip>
				</el-badge> -->
				<!-- 全屏显示 -->
				<div class="btn-fullscreen" @click="handleFullScreen">
				    <el-tooltip effect="dark" :content="fullscreen?header.header_5:header.header_6" placement="bottom">
				        <i class="el-icon-rank"></i>
				    </el-tooltip>
				</div>
            </div>
        </div>
    </div>
</template>
<script>
import bus from '../common/bus';
export default {
	inject: ['reload'], //在子组件中通过inject调用
    data() {
        return {
			web_suuid: sessionStorage.getItem('ms_web_suuid'), //web侧 登录ID
			web_semail: sessionStorage.getItem('ms_username'), //web侧 登录邮箱
			// userimg:sessionStorage.getItem('ms_userimg') + "?timestamp=" + new Date().getTime(),
			// defaultImg:'this.src="' + require("../../assets/img/users_40.png") +'";this.onerror=null',
			username:sessionStorage.getItem('ms_username'),
			language:'',
            collapse: false,
            fullscreen: false,
            message: 0,
			contentMessage:'',
			header: {
				header_0: "口袋家园服务端",
				header_1: "日本語",
				header_2: "简体中文",
				header_3: "繁体中文",
				header_4: "English",
				header_5: "取消全屏",
				header_6: "全屏",
				header_7: "有",
				header_8: "条未读消息",
				header_9: "消息中心",
				header_10: "个人资料",
				header_11: "退出登录"
			},
        };
    },
	created(){
		 // this.setMessageToolTip();

		 // this.getBellCount();

	},
    computed: {
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
			let me = this;
			switch (command){
				case 'personInfo':
					this.$router.push('/userCenter');
					break;
				case 'loginout':
					sessionStorage.removeItem('ms_userimg');
					sessionStorage.removeItem('ms_username');
					sessionStorage.removeItem('ms_web_suuid');
					sessionStorage.removeItem('ms_password');
					sessionStorage.removeItem('ms_role');

					this.isRouterAlive = false
					this.$nextTick(function () {
						this.isRouterAlive = true
					})
					
					//this.closeAll();
					this.$router.push('/login');
					location.reload();
					break;
				default:
					sessionStorage.removeItem('ms_userimg');
					sessionStorage.removeItem('ms_username');
					sessionStorage.removeItem('ms_web_suuid');
					sessionStorage.removeItem('ms_password');
					sessionStorage.removeItem('ms_role');
					this.$router.push('/login');
					break;
			}
        },
		// 关闭全部标签
		closeAll() {
			this.COMM.tagsLists = [];
			this.tagsList = this.COMM.tagsLists;
			// this.$router.push('/');
			if(this.$router.resolve({name: 'Dashboard'}).route.matched.length !== 0){
				this.$router.push('/dashboard');
			} else if (this.$router.resolve({name: 'agentDashboard'}).route.matched.length !== 0){
				this.$router.push('/agentDashboard');
			}else if(this.$router.resolve({name: 'shopDashboard'}).route.matched.length !== 0){
				this.$router.push('/shopDashboard');
			}
			this.reload();
		},
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
		// 已读消息数变更方法
		messageRead() {
			this.message = this.message-1;
		},
		setMessageToolTip(){
			//消息 message?`有${message}条未读消息`:`消息中心`
			if(this.message == 0)
			{
				this.contentMessage = this.header.header_9; //"消息中心"
			}
			else
			{
				this.contentMessage = this.header.header_7 + this.message + this.header.header_8; // "有"+this.message+"条未读消息"
			}
		},
		// 获取消息数量
		getBellCount() {
			// 先获取当前用户权限
			// var postUrl = 'WCF/WEB/svcUAA.svc/GET_UAA_ROLE';
			// //网络请求接口
			// this.$axios
			// 	.post(
			// 		//请求的url
			// 		postUrl,
			// 		//请求参数
			// 		{
			// 			sUAAID: this.web_suuid, //web侧 登录ID  tihs.web_suuid
			// 			sEmail: this.web_semail, //web侧 登录邮箱
			// 			sLanguage: '0' //语言
			// 		}
			// 	)
			// 	.then(response => {
			// 		//请求成功返回的数据
			// 		let UAAROLE = response.data.KKDT[0].UAAROLE; // 身份
			// 		// 获取表格数据
			// 		var apiUrl = 'WCF/WEB/svcNAC.svc/Get_Message_List_Count';
			// 		this.$axios
			// 			.post(
			// 				//请求的url
			// 				apiUrl,
			// 				//请求参数
			// 				{
			// 					sUAAID: this.web_suuid, //web侧 登录ID  tihs.web_suuid
			// 					sEmail: this.web_semail, //web侧 登录邮箱
			// 					TITL: '',
			// 					START: '',
			// 					END: '',
			// 					UAAROLE: UAAROLE,
			// 					sLanguage: '0', //语言
			// 				}
			// 			)
			// 			.then(response => {
			// 				//请求成功返回的数据
			// 				if (response.data.KKDT !== null && response.data.KKDT !== '') {
			// 					response.data.KKDT.forEach((team,index)=>{
			// 						this.message += Number(team.READCOUNT);
			// 					});
			// 				} else {
			// 					this.message = 0;
			// 				}
			// 			})
			// 			.catch(error => {
			// 				this.$message({
			// 					type: 'error'
			// 				});
			// 			});
			// 	})
			// 	.catch(error => {
			// 	});
		},
		changeImg() {
			this.userimg = sessionStorage.getItem('ms_userimg');
		}
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}
.header .logo {
    float: left;
    width: 300px;
    line-height: 70px;
}
.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell{
	position: relative;
	width: 30px;
	height: 30px;
	margin-right: 20px;
	text-align: center;
	border-radius: 15px;
	cursor: pointer;
}
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
/* .btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
} */
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-right: 25px;
}
.user-avator {
    margin-right: 15px;
}
.user-language{
	margin-right: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
</style>
